declare namespace $ {

	type $mol_link__arg_bog_bzrl_app_nav_1 = $mol_type_enforce<
		({ 
			'tab': string,
			'section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_bzrl_app_nav_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_bog_bzrl_app_nav_3 = $mol_type_enforce<
		({ 
			'tab': string,
			'section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_bzrl_app_nav_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_image__uri_bog_bzrl_app_nav_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_button_minor__sub_bog_bzrl_app_nav_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_bzrl_app_nav extends $mol_view {
		rent_label( ): string
		Rent_button( ): $mol_link
		let_label( ): string
		Let_link( ): $mol_link
		home_icon_img( ): $mol_image
		Home_icon( ): $mol_button_minor
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=nav.view.tree.d.ts.map